import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export async function getRoleNameById(projectId, roleId, callback) {
	console.log('getRoleNameById', projectId, roleId);
	firebaseRef
		.ref('/kavtek_roles/' + projectId + '/' + roleId)
		.once('value', (snapshot) => {
			var roleName;
			roleName = snapshot.val().roleName;

			console.log('roleName', snapshot.val());

			callback(roleName);
		});
}
